// extracted by mini-css-extract-plugin
export default {"position":"PVC8W6j9","position--left":"Xp342PL1","position--center":"CCjR8Ded","position--right":"EXMZ3oEs"};